// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright (c) 2025 Robert Schiwon
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

/* dialog */

sf-splash > dialog {
  width: 50%;
}

sf-splash > dialog .sf-version {
  font-size: 8px;
  padding-left: 0.5em;
}

sf-splash > dialog::backdrop {
  background: rgba(0, 0, 0, 0.5);
}

sf-splash > dialog[open] {
  animation: fadein 0.1s forwards;
}

/* this does not work, a class needs to be added manually for a closing animation */
/* https://stackoverflow.com/a/71984473 */
/* sf-splash > dialog::not([open]) {
  animation: fadein 0.5s backwards;
} */

@keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@media screen and (max-width: 576px) {
  sf-splash > dialog {
    width: 80%;
  }
}

/* content */

sf-splash > dialog {
  font-family: sans-serif;
  font-size: 14px;
}

sf-splash .sf-title {
  display: flex;
  justify-content: center;
}

sf-splash img.sf-logo {
  height: calc(5 * 14px);
}

sf-splash .sf-initializing {
  font-weight: bold;
  width: 100%;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/dialogs/Splash.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;EAmBE;;AAEF,WAAW;;AAEX;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,mFAAmF;AACnF,yCAAyC;AACzC;;GAEG;;AAEH;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,YAAY;;AAEZ;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB","sourcesContent":["/**\n * Copyright (c) 2025 Robert Schiwon\n *\n * Permission is hereby granted, free of charge, to any person obtaining a copy of\n * this software and associated documentation files (the \"Software\"), to deal in\n * the Software without restriction, including without limitation the rights to\n * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\n * the Software, and to permit persons to whom the Software is furnished to do so,\n * subject to the following conditions:\n *\n * The above copyright notice and this permission notice shall be included in all\n * copies or substantial portions of the Software.\n *\n * THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\n * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\n * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\n * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\n * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n */\n\n/* dialog */\n\nsf-splash > dialog {\n  width: 50%;\n}\n\nsf-splash > dialog .sf-version {\n  font-size: 8px;\n  padding-left: 0.5em;\n}\n\nsf-splash > dialog::backdrop {\n  background: rgba(0, 0, 0, 0.5);\n}\n\nsf-splash > dialog[open] {\n  animation: fadein 0.1s forwards;\n}\n\n/* this does not work, a class needs to be added manually for a closing animation */\n/* https://stackoverflow.com/a/71984473 */\n/* sf-splash > dialog::not([open]) {\n  animation: fadein 0.5s backwards;\n} */\n\n@keyframes fadein {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  sf-splash > dialog {\n    width: 80%;\n  }\n}\n\n/* content */\n\nsf-splash > dialog {\n  font-family: sans-serif;\n  font-size: 14px;\n}\n\nsf-splash .sf-title {\n  display: flex;\n  justify-content: center;\n}\n\nsf-splash img.sf-logo {\n  height: calc(5 * 14px);\n}\n\nsf-splash .sf-initializing {\n  font-weight: bold;\n  width: 100%;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
